import { createAction } from '@reduxjs/toolkit';

import { workspaceApi } from '@/api/workspace/index.ts';
import { selectWorkspaceToSave } from '@/api/workspace/selectors.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { selectActiveTab } from '@/store/tabs/slice.ts';

/////////////////////////////////////////////////////
// action to dispatch on user click "stop sharing" //
/////////////////////////////////////////////////////
export const onClickStopSharingTab = createAction('onClickStopSharingTab');

/////////////////////////////////////////////////////////////////
// on user click "stop sharing" => unshare then save workspace //
/////////////////////////////////////////////////////////////////
export function registerStopSharingTabListener(startAppListening: StartAppListening) {
  startAppListening({
    actionCreator: onClickStopSharingTab,
    effect: async (_action, { getState, dispatch }) => {
      ///////////////////////
      // DELETE shared tab //
      ///////////////////////
      const selectedTab = selectActiveTab(getState());
      if (!selectedTab) {
        return;
      }

      const result = await dispatch(workspaceApi.endpoints.stopSharing.initiate({ tabId: selectedTab.id }));

      /////////////////////////
      // POST save workspace //
      /////////////////////////
      // save workspace after tab unshared, to save it again in user personnal workspace
      if (!result.error) {
        const workspace = selectWorkspaceToSave(getState());
        dispatch(workspaceApi.endpoints.saveWorkspace.initiate(workspace));
      }
    },
  });
}
